import catalog from '../../../../static_data/fonts/catalog.json'

// A resolved face from the shared catalog: Unicode-keyed metrics and an
// optional code point -> byte encoding table. Mirrors Graphics.FontFace.
export type FontFace = {
  id: string
  metrics: { widths: Record<string, number>; units_per_em: number }
  encoding: Record<string, number> | null
}

// Asset loading and concrete font registration live here, outside layout.
const faces = new Map<string, FontFace>()
const encodings: Record<string, Record<string, number>> = catalog.encodings
for (const [id, definition] of Object.entries(catalog.faces)) {
  let encoding = null
  if (definition.encoding != null) encoding = encodings[definition.encoding]
  const face = { id, metrics: definition.metrics, encoding }
  faces.set(`${definition.family}:${definition.weight}`, face)
}

export const FontCatalog = {
  resolve({ family, weight = 'normal' }: { family: string; weight?: string }): FontFace {
    const face = faces.get(`${family}:${weight}`)
    if (!face) throw new Error(`Unsupported font: ${family} ${weight}`)
    return face
  }
}
